import type { McpToken } from '@/api/types';
import type { SortValue } from '@/ui/sortRows';

import type { TokenFilters } from './TokensToolbar';

/** Names read A to Z first; the dates open newest first (useSort's rule), and "Never used" goes last whichever way. */
export const ASCENDING_FIRST: ReadonlySet<string> = new Set(['name']);

export const TOKEN_SORT: Record<string, (token: McpToken) => SortValue> = {
  name: (token) => token.name,
  expires: (token) => new Date(token.expires_at),
  lastUsed: (token) => (token.last_used_at ? new Date(token.last_used_at) : null),
  created: (token) => new Date(token.created_at),
};

export const NO_FILTERS: TokenFilters = { q: '', status: [], scope: [] };

export function matchesToken(token: McpToken, { q, status, scope }: TokenFilters): boolean {
  if (q && !token.name.toLowerCase().includes(q.trim().toLowerCase())) return false;
  if (status.length > 0 && !status.includes(token.expired ? 'expired' : 'active')) return false;
  return scope.length === 0 || scope.some((key) => token.scopes.includes(key));
}
